import script from "./BaseCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseCard.vue?vue&type=script&setup=true&lang=js"

import "./BaseCard.vue?vue&type=style&index=0&id=2fcc9b6e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fcc9b6e"]])

export default __exports__